module.exports = __webpack_public_path__ + "static/media/conference.ad3a8e8a.jpg";